import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import JsonData from "./data/data.json";
import "./App.css";
import AlbumPage from "./components/albumPage";
import LandingPage from "./components/landingPage";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToHash from "./components/ScrollToHash";

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
      <ScrollToHash />
      <Navigation />

      <Routes>
        <Route path="/" element={<LandingPage landingPageData={landingPageData} />} />
        <Route path="/albums/:albumId" element={<AlbumPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
